module.exports = __webpack_public_path__ + "img/accessor-sq.cc79a6dd.svg";